import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AutenticacionService } from './autenticacion.service';
import { Pregunta } from '../_models/pregunta';

@Injectable({
  providedIn: 'root'
})
export class BancoPreguntasService {

  private rutServiciosRoles = AppSettings.rutServiciosAPL + '/api/preguntas/';

  constructor( private httpClient: HttpClient, private autenticacionService: AutenticacionService ) {
  }

  listado(): Observable<Pregunta[]> {
    return this.httpClient.get( this.rutServiciosRoles ).pipe( map( res => res as Pregunta[] ) );
  }

  obtener( idPregunta: string ): Observable<Pregunta> {
    return this.httpClient.get( this.rutServiciosRoles + idPregunta ).pipe( map( res => res as Pregunta ) );
  }

  agregar( pregunta: Pregunta ): Observable<Pregunta> {
    pregunta.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    pregunta.auditoriaFecha = new Date( Date.now() );
    return this.httpClient.post( this.rutServiciosRoles, pregunta ).pipe( map( res => res as Pregunta ) );
  }

  actualizar( pregunta: Pregunta ): Observable<any> {
    return this.httpClient.put( this.rutServiciosRoles, pregunta ).pipe( map( res => res as any) );
  }

  visualizar( idPregunta: string ): Observable<Pregunta> {
    return this.httpClient.get( this.rutServiciosRoles + 'visualizar/' + idPregunta ).pipe( map( res => res as any ) );
  }

}
